module.exports = __webpack_public_path__ + "img/driving_lic.97f9c8f4.svg";